import React from "react";
import {connect} from "react-redux";
import {Button, Form, Input, Modal, Space, message} from "antd";
import {displayErrors} from "../../libs/utils";
import {bulkDeleteIPAddressBlocks} from "../../actions/firewall";

class DeleteBulkIPAddressesModal extends React.Component {
    state = {
        ipAddresses: '',
        deleting: false,
    };

    closeModal(reload = false) {
        this.setState({
            ipAddresses: '',
            deleting: false,
        });

        this.props.close();

        if(reload) {
            this.props.reloadBlocks();
        }
    }

    deleteIPAddresses() {
        let ip_addresses = this.state.ipAddresses.trim().split('\n');

        if(ip_addresses.length === 0) {
            return message.error('Enter at least 1 IP address!');
        }

        let data = { action: 'DELETE', ip_addresses };

        this.setState({ deleting: true });

        this.props.bulkDeleteIPAddressBlocks(data, () => {
            message.success('IP addresses successfully deleted!');
            this.setState({ deleting: false });
            this.closeModal(true);
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ deleting: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        const { TextArea } = Input;

        return(
            <Modal
                title='Bulk Delete IP Address Blocks'
                open={this.props.showModal}
                destroyOnClose={true}
                footer={
                    <Space>
                        <Button disabled={this.state.deleting} onClick={() => this.closeModal()}>Close</Button>
                        <Button type='primary' disabled={this.state.deleting} loading={this.state.deleting} onClick={() => this.deleteIPAddresses()}>Delete</Button>
                    </Space>
                }
                onCancel={() => this.closeModal()}>

                <Form layout='vertical'>
                    <Form.Item label='IP addresses'>
                        <TextArea rows={15} onChange={(e) => this.setState({ ipAddresses: e.target.value })} />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

export default connect(null, { bulkDeleteIPAddressBlocks  })(DeleteBulkIPAddressesModal);